import { jsx as C } from "react/jsx-runtime";
const n = ({
  width: o,
  height: t,
  className: r
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: r,
    fill: "none",
    height: t,
    viewBox: "0 0 16 16",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M11.8584 0.950195C13.2468 0.950217 14.365 2.10196 14.3652 3.4834C14.3652 4.88611 13.2261 6.01756 11.8584 6.01758C11.1265 6.01758 10.4557 5.69376 10 5.16699L6.62207 6.93555C6.75657 7.25774 6.85352 7.61828 6.85352 8C6.85352 8.3798 6.77603 8.74065 6.62402 9.06543L10 10.832C10.4548 10.3058 11.1066 9.98242 11.8584 9.98242C13.2256 9.98244 14.3848 11.1134 14.3848 12.5166C14.3845 13.9188 13.2669 15.0497 11.8789 15.0498C10.4905 15.0498 9.37232 13.898 9.37207 12.5166C9.37207 12.1973 9.429 11.9158 9.52344 11.6377L6.08105 9.8457C5.62773 10.2909 5.01738 10.5547 4.34668 10.5547C2.95828 10.5545 1.84082 9.40205 1.84082 8.02051C1.84083 6.63886 2.97919 5.48633 4.32715 5.48633C4.99738 5.48644 5.60738 5.74955 6.06055 6.19434L9.50391 4.40234C9.40965 4.12458 9.35162 3.84423 9.35156 3.52539C9.35156 2.14481 10.4688 0.950195 11.8584 0.950195ZM11.8584 10.8828C10.9732 10.8828 10.2639 11.5987 10.2637 12.4951C10.2637 13.3914 10.9929 14.1084 11.8584 14.1084C12.7239 14.1084 13.4531 13.3914 13.4531 12.4951C13.4529 11.5987 12.7436 10.8828 11.8584 10.8828ZM4.34668 6.4082C3.46185 6.4084 2.75294 7.14409 2.75293 8.02051C2.75293 8.91665 3.48133 9.63262 4.34668 9.63281C5.21178 9.63281 5.94141 8.89665 5.94141 8.02051C5.94139 7.12426 5.21217 6.4082 4.34668 6.4082ZM11.8584 1.93262C10.9726 1.93262 10.2637 2.64966 10.2637 3.52539C10.2639 4.42265 10.9739 5.1582 11.8584 5.1582C12.7432 5.15818 13.4529 4.42223 13.4531 3.5459C13.4531 2.64965 12.7239 1.93264 11.8584 1.93262Z",
        fill: "#333333",
        stroke: "currentColor",
        strokeWidth: "0.1"
      }
    )
  }
);
export {
  n as Content
};
